import { render } from "./index.vue?vue&type=template&id=f96d742e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f96d742e&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\vue-ztxinxi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f96d742e"]])

export default __exports__